// extracted by mini-css-extract-plugin
module.exports = {"modal_block":"ReviewCreatedProposalModal_modal_block__3gp_a","footer":"ReviewCreatedProposalModal_footer__7gmvi","cancel_button":"ReviewCreatedProposalModal_cancel_button__1tZrZ"};